export default __webpack_public_path__ + "static/media/ic_caret_right_filter.f51f51ec.svg";